<script>
  import Button from '@/components/ui/Button.svelte';
  import { router } from '@inertiajs/svelte'

  let { organization = null, org_types = [], flash = {} } = $props()
  // svelte-ignore state_referenced_locally
  const initialOrganization = organization

  let form = $state({
    name: initialOrganization?.name || '',
    domain: initialOrganization?.domain || '',
    org_type: initialOrganization?.org_type || 'private',
    auto_verify: initialOrganization?.auto_verify ?? true,
    verification_enabled: initialOrganization?.verification_enabled ?? true,
    login_allowed: initialOrganization?.login_allowed ?? true,
    logo_url: initialOrganization?.logo_url || '',
    employee_count: initialOrganization?.employee_count || ''
  })

  let isEdit = $derived(!!organization?.id)
  let isSubmitting = $state(false)

  function getTypeLabel(type) {
    const labels = {
      public: '공기업',
      private: '민간기업',
      financial: '금융기관',
      government: '정부기관'
    }
    return labels[type] || type
  }

  function handleSubmit() {
    isSubmitting = true

    const options = {
      onFinish: () => {
        isSubmitting = false
      }
    }

    if (isEdit) {
      router.patch(`/admin/organizations/${organization.id}`, { organization: form }, options)
    } else {
      router.post('/admin/organizations', { organization: form }, options)
    }
  }
</script>

<!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-caption text-content-tertiary mb-6">
    <a href="/admin" class="hover:text-primary transition-colors">관리자</a>
    <span>/</span>
    <a href="/admin/organizations" class="hover:text-primary transition-colors">기관</a>
    <span>/</span>
    <span class="text-content">{isEdit ? '수정' : '새 기관 등록'}</span>
  </div>

  <main class="max-w-2xl">
    {#if flash.alert}
      <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
        {flash.alert}
      </div>
    {/if}

    <h2 class="text-h1 text-content mb-6">{isEdit ? '기관 정보 수정' : '새 기관 등록'}</h2>

    <form onsubmit={(e) => { e.preventDefault(); handleSubmit(); }} class="card card-bordered p-6 shadow-md space-y-6">
      <!-- 기관명 -->
      <div>
        <label for="name" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">기관/회사명 *</label>
        <input
          id="name"
          type="text"
          bind:value={form.name}
          required
          placeholder="예: 한국전력공사"
          class="input w-full py-2.5"
        />
      </div>

      <!-- 도메인 -->
      <div>
        <label for="domain" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">이메일 도메인 *</label>
        <input
          id="domain"
          type="text"
          bind:value={form.domain}
          required
          placeholder="예: kepco.co.kr"
          class="input w-full py-2.5"
        />
        <p class="text-caption text-content-tertiary mt-1">회사 이메일 도메인 (@제외). 소속 인증에 사용됩니다.</p>
      </div>

      <!-- 유형 -->
      <div>
        <label for="org_type" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">기관 유형 *</label>
        <select id="org_type" bind:value={form.org_type} class="select w-full">
          {#each org_types as type}
            <option value={type}>{getTypeLabel(type)}</option>
          {/each}
        </select>
      </div>

      <!-- 직원 수 -->
      <div>
        <label for="employee_count" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">직원 수 (선택)</label>
        <input
          id="employee_count"
          type="number"
          bind:value={form.employee_count}
          placeholder="예: 5000"
          class="input w-full py-2.5"
        />
      </div>

      <!-- 로고 URL -->
      <div>
        <label for="logo_url" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">로고 URL (선택)</label>
        <input
          id="logo_url"
          type="url"
          bind:value={form.logo_url}
          placeholder="https://..."
          class="input w-full py-2.5"
        />
      </div>

      <!-- 자동 인증 -->
      <div class="flex items-center gap-3">
        <input
          id="auto_verify"
          type="checkbox"
          bind:checked={form.auto_verify}
          class="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary"
        />
        <label for="auto_verify" class="text-body1 text-gray-700 dark:text-dark-text-medium">
          자동 인증 활성화
        </label>
        <span class="text-caption text-content-tertiary">해당 도메인 이메일 인증 시 자동으로 정회원 승격</span>
      </div>

      <div class="flex items-center gap-3">
        <input
          id="verification_enabled"
          type="checkbox"
          bind:checked={form.verification_enabled}
          class="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary"
        />
        <label for="verification_enabled" class="text-body1 text-gray-700 dark:text-dark-text-medium">
          도메인 인증 사용
        </label>
        <span class="text-caption text-content-tertiary">비활성화 시 회사 인증 상태는 미인증으로 유지됩니다.</span>
      </div>

      <div class="flex items-center gap-3">
        <input
          id="login_allowed"
          type="checkbox"
          bind:checked={form.login_allowed}
          class="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary"
        />
        <label for="login_allowed" class="text-body1 text-gray-700 dark:text-dark-text-medium">
          도메인 사용자 이용 허용
        </label>
        <span class="text-caption text-content-tertiary">비활성화 시 해당 도메인은 로그인할 수 없습니다.</span>
      </div>

      <!-- Submit -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-default">
        <a href="/admin/organizations" class="btn btn-secondary btn-md">취소</a>
        <Button type="submit" size="md" loading={isSubmitting} loadingLabel={isEdit ? '수정 중...' : '등록 중...'} disabled={!form.name || !form.domain}>
          {isEdit ? '수정' : '등록'}
        </Button>
      </div>
    </form>
  </main>
